import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

const nav = createNavigation(routing);

export const { Link, usePathname, useRouter } = nav;

/**
 * next-intl의 redirect는 매우 복잡한 조건부 제네릭 타입이라, TypeScript가 `if (!x) redirect(...)`
 * 패턴에서 이후 코드의 null narrowing을 못 잡아낸다(반환 타입이 never인 게 분명한데도).
 * 여기서 단순한 시그니처로 다시 노출해 호출부에서 항상 narrowing이 되게 한다.
 */
export const redirect: (args: { href: string; locale: string }) => never = nav.redirect;
